// src/TutorRegistrationForm.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Register.css'; // Import the CSS file for the Register page

const TutorRegistrationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    level: 'beginner',
    password: '',
    confirm_password: '',
  });

  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the specific error for the field being updated
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name) newErrors.first_name = 'First name is required';
    if (!formData.last_name) newErrors.last_name = 'Last name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.phone_number) newErrors.phone_number = 'Phone number is required';
    if (!formData.password) newErrors.password = 'Password is required';
    if (!formData.confirm_password) newErrors.confirm_password = 'Confirm password is required';
    if (formData.password !== formData.confirm_password) newErrors.confirm_password = 'Passwords do not match';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted');
    console.log('Form data:', formData);

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('https://simplyigbo-backend.onrender.com/api/tutor', formData);
      console.log('Response:', response);
      if (response.status === 201) {
        setMessage('Tutor created successfully');
        setErrors({});
        setTimeout(() => {
          navigate('/'); // Redirect to landing page after a brief delay
        }, 2000); // 2 seconds delay
      }
    } catch (error) {
      console.error('Error:', error);
      if (error.response) {
        if (error.response.status === 409) {
          setMessage('Tutor with this email already exists');
        } else if (error.response.status === 400) {
          setMessage(error.response.data.error);
        } else {
          setMessage('Registration failed');
        }
      } else if (error.code === 'ERR_NETWORK') {
        setMessage('Network error, please try again');
      } else {
        setMessage('Registration failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="register-section">
      <div className="register-container" data-aos="fade-up">
        <h2 className="register-title" data-aos="fade-down">Tutor Registration</h2>
        <p className="register-subtitle" data-aos="fade-down">Please Enter Your Details To Register as a Tutor</p>
        <div className="register-content">
          {/* Right Div: Registration Form */}
          <div className="register-form-container" data-aos="fade-left">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="first_name" className="form-label">First Name</label>
                <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  className="form-input"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
                {errors.first_name && <p className="error-message">{errors.first_name}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="last_name" className="form-label">Last Name</label>
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  className="form-input"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
                {errors.last_name && <p className="error-message">{errors.last_name}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <p className="error-message">{errors.email}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="phone_number" className="form-label">Phone Number</label>
                <input
                  type="text"
                  id="phone_number"
                  name="phone_number"
                  className="form-input"
                  value={formData.phone_number}
                  onChange={handleChange}
                  required
                />
                {errors.phone_number && <p className="error-message">{errors.phone_number}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="level" className="form-label">Level</label>
                <select
                  id="level"
                  name="level"
                  className="form-input"
                  value={formData.level}
                  onChange={handleChange}
                  required
                >
                  <option value="beginner">Beginner</option>
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                {errors.password && <p className="error-message">{errors.password}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="confirm_password" className="form-label">Confirm Password</label>
                <input
                  type="password"
                  id="confirm_password"
                  name="confirm_password"
                  className="form-input"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  required
                />
                {errors.confirm_password && <p className="error-message">{errors.confirm_password}</p>}
              </div>
              <div className="form-submit">
                <button type="submit" className="form-button" disabled={loading}>
                  {loading ? 'Loading...' : 'Register'}
                </button>
              </div>
              {message && <p className='messagecolor'>{message}</p>}
              <div className="form-footer">
                <p>Already have an account? <a href="/login" className="form-link">Login here</a></p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TutorRegistrationForm;